








































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import FilterChart from './Components/FilterChart.vue'
import TableMenu from './Components/TableMenu.vue'
import TableMenu1 from './Components/TableDealer.vue'
import LineChart from './Components/LineChart/LineChart.vue'
import PieChart from './Components/PieChart/PieChart.vue'
import { AuthModule } from '@/app/store/modules/auth'
import { DashboardModule } from '@/app/store/modules/dashboard'

@Component({
  name: 'DashboardAdmin',
  components: {
    'top-menu': TopMenu,
    'line-chart': LineChart,
    'pie-chart': PieChart,
    'table-menu': TableMenu,
    'table-dealer': TableMenu1,
    'filter-chart': FilterChart,
  },
})
export default class extends Vue {
  public created() {
    this.getDashboardData()
  }
  public getDashboardData() {
    DashboardModule.getDashboardData()
  }
  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role

    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }
  public get topMenu() {
    return DashboardModule.dashboardData.topMenuData
  }
  public get userActive() {
    return DashboardModule.dashboardData.userActiveData
  }

  public get userDealerUnregister() {
    return DashboardModule.dashboardData.userDealerUnregister
  }
  public get userDealerNotAccessed() {
    return DashboardModule.dashboardData.userDealerNotAccessed
  }
  public get mostViewContent() {
    return DashboardModule.dashboardData.categoryMaterialsData
  }

  public get dataCharts() {
    return DashboardModule.dashboardData.chartData
  }

  public get dataPieCharts() {
    return DashboardModule.dashboardData.chartDealerNotAccessed
  }
  public get dataPieCharts1() {
    return DashboardModule.dashboardData.chartDealerUnregister
  }
  public get isLoading(): boolean {
    return DashboardModule.isLoading
  }
  private nameChartsPie1 = 'SFID Registration Ratio'
  private nameChartsPie2 = 'SFID Access Ratio'
  private nameCharts = 'Graphic Top 10 Dealer (Dealer Code vs Total Access)'
}
